import { EAccountPlansType } from "../../Enum/EAccountPlansType"
import { BaseModel } from "../Generics/BaseModel"
import { CompanyEntity } from "../Company/CompanyEntity"
import { isValidBrazilianPhoneWithDdd } from "../../utils/phoneFormat"

export class SignUp extends BaseModel {
  name: string

  userName: string

  password: string

  confirmPassword: string

  email: string

  ownerPhone: string

  eaccountPlansType: EAccountPlansType

  addCompanyDto: CompanyEntity

  billingEmail: string

  subscriptionExternalId: string

  isPaymentMethodConfigured: boolean

  isAgreedWithTerms: boolean

  constructor(data: Partial<SignUp> = {}) {
    super()

    this.isAgreedWithTerms = data.isAgreedWithTerms ?? false

    this.name = data.name ?? ""

    this.userName = data.userName ?? ""

    this.password = data.password ?? ""

    this.confirmPassword = data.confirmPassword ?? ""

    this.email = data.email ?? ""

    this.ownerPhone = data.ownerPhone ?? ""

    this.eaccountPlansType = data.eaccountPlansType ?? EAccountPlansType.None

    this.billingEmail = data.billingEmail ?? ""

    this.subscriptionExternalId = data.subscriptionExternalId ?? ""

    this.isPaymentMethodConfigured = data.isPaymentMethodConfigured ?? false

    this.addCompanyDto = data.addCompanyDto ? new CompanyEntity(data.addCompanyDto) : new CompanyEntity({})
  }

  validStep() {
    return (
      this.name != "" &&
      isValidBrazilianPhoneWithDdd(this.ownerPhone) &&
      this.addCompanyDto.companyName != "" &&
      this.isAgreedWithTerms === true
    )
  }
}
